/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-08 10:47:58
 * @LastEditTime: 2022-04-18 16:02:05
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\typeManage\utils.js
 */

const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '理赔类型'
  },
  dataIndex: 'name',
  key: 'name'
}, {
  slots: {
    title: '排序'
  },
  dataIndex: 'sort',
  key: 'sort',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 330,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const REPLACE_DEPARTMENT_FIELDS = {
  children: 'children',
  title: 'name',
  key: 'claimsTypeId',
  value: 'claimsTypeId'
};
const statusSelectList = [{
  key: '',
  name: '全部'
}, {
  key: 0,
  name: '已禁用'
}, {
  key: 1,
  name: '已启用'
}];
export { columns, pagination, REPLACE_DEPARTMENT_FIELDS, statusSelectList };